import React from 'react';
import { useField, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import FeatureWrapper from '../../../ai-features/feature-wrapper/FeatureWrapper';
import AIChatsContainer from '../../../ai-features/ai-chats-container/AIChatsContainer';
import arraysHaveSameElements from '../../../../utils/arraysHaveSameElements';

function AIChatsFormInner({ onSubmit }) {
  const { submitting } = useFormState();

  const aiChatsFields = useField('assignedAIChats');
  const companyAIChats = useSelector((state) => state.customers.customerInfo?.aiChatTypes);

  const isSaveDisabled = arraysHaveSameElements(
    aiChatsFields.input.value.map(({ id }) => id),
    companyAIChats,
  );

  return (
    <FeatureWrapper title='AI Chats' onSave={onSubmit} isSaving={submitting} isSaveDisabled={isSaveDisabled}>
      {({ search, disabled }) => <AIChatsContainer search={search} disabled={disabled} fieldName='assignedAIChats' />}
    </FeatureWrapper>
  );
}

export default AIChatsFormInner;
